import { downloadFile } from '@mi-front/core';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Button } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';
import { apiClient } from '../../../../../../../api';

export function DownloadMediaBtn({ id, mediaType }: { id: string; mediaType: 'AUDIO' | 'VIDEO' }) {
  const { $t } = useIntl();
  const mutation = useMutation({
    mutationFn: () =>
      apiClient.fragments.generateDownloadUrl(id, mediaType).then((data) => {
        downloadFile(`${data.url}&response-content-disposition=attachment;`, false);
      }),
  });

  return (
    <Button
      color="inherit"
      variant="outlined"
      size="small"
      loading={mutation.isPending}
      onClick={() => mutation.mutate()}
      startIcon={mediaType === 'AUDIO' ? <AudioFileIcon /> : <VideoFileIcon />}
    >
      <FormattedMessage
        id="fragments.export.downloadMedia"
        defaultMessage="Descargar {type}"
        values={{
          type:
            mediaType === 'AUDIO'
              ? $t({ id: 'common.audio', defaultMessage: 'audio' })
              : $t({ id: 'common.video', defaultMessage: 'video' }),
        }}
      />
    </Button>
  );
}
